import React from 'react';

function SuggestedSwaps({ swapExercises = [] }) {
    return (
        <div className="swap-exercises-list-container">
            <label className="swap-exercises-label">Suggested Swaps</label>
            {swapExercises.length > 0 ? (
                <span className="swap-exercises-list">
                    {swapExercises.map(s => s.title).join(', ')}
                </span>
            ) : (
                <p className="exercise-preview-empty">No swaps added yet.</p>
            )}
        </div>
    );
}

export default SuggestedSwaps;



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/SuggestedSwaps.jsx